import * as z from "zod"
import { DATE_RANGE } from "@/components/ui/year-month-picker"

/**
 * Shared Zod schema for year-month validation across the application
 * Enforces the date range 2005-01 to 2024-12 for all DLOM calculations
 */
export const yearMonthSchema = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[0-2])$/, "Enter as YYYY-MM")
  .refine(
    (val) => val >= DATE_RANGE.MIN && val <= DATE_RANGE.MAX,
    `Valuation month must be between ${DATE_RANGE.MIN} and ${DATE_RANGE.MAX}`
  )

/**
 * Alternative validation for components that use different date format validation
 */
export const yearMonthSchemaAlt = z.string()
  .regex(/^\d{4}-\d{2}$/, "Please enter in YYYY-MM format")
  .refine((date) => {
    const [year, month] = date.split('-').map(Number);
    const inputDate = new Date(year, month - 1);
    const [minYear, minMonth] = DATE_RANGE.MIN.split('-').map(Number);
    const [maxYear, maxMonth] = DATE_RANGE.MAX.split('-').map(Number);
    const minDate = new Date(minYear, minMonth - 1);
    const maxDate = new Date(maxYear, maxMonth - 1);
    return inputDate >= minDate && inputDate <= maxDate;
  }, `Date must be between ${DATE_RANGE.MIN} and ${DATE_RANGE.MAX}`)

/**
 * Utility function to check if a date string is within the valid range
 */
export const isDateInRange = (dateString: string): boolean => {
  return dateString >= DATE_RANGE.MIN && dateString <= DATE_RANGE.MAX
}
